import { Route, Routes } from "react-router-dom";
import Settings from "./pages/admin/changepass";
import Earthquake from "./pages/admin/earthquake";
import Typhoon from "./pages/admin/typhoon";
import AdminDashboard from "./pages/admin/dashboard";
import Dashboard from "./pages/dashboard";
import Login from "./pages/login";
const Routers = () => {
    return (
        <Routes>
        <Route path="/" element={<Login />}/>
            <Route path="dashboard" element={<Dashboard />}>
            <Route path="admin" element={<AdminDashboard />}/>
            <Route path="typhoon" element={<Typhoon />}/>
            <Route path="earthquake" element={<Earthquake />}/>
            <Route path="settings" element={<Settings />}/>
            </Route>
            
        </Routes>
    )
}

export default Routers;